// Site configuration
export const SITE_CONFIG = {
  domain: 'mdsweets.shop',
  url: 'https://mdsweets.shop',
  name: 'MD Sweets Caterers',
  description: 'MD Sweets Caterers - Order delicious sweets online',
  email: 'contact@mdsweets.shop',
  phone: '+91 98765 43210',
  social: {
    facebook: '', // Add your social media links
    instagram: '',
    twitter: ''
  }
};

export default SITE_CONFIG;
